// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__2W-li","question":"Question_question__2wGXH","description":"Question_description__34XlF"};